import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import { useAuth } from 'src/contexts/AuthContext'

function LoadingScreen() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      Chargement…
    </Box>
  )
}

export function RootLayout() {
  const { loading } = useAuth()

  if (loading) {
    return <LoadingScreen />
  }

  return <Outlet /> 
}
